import React from "react";

const GenerateIconWithNumber = (props: any) => {
  return (
    <svg
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.59812 13H0.490078V11.715L2.68348 9.49773C3.12574 9.04352 3.48035 8.665 3.7473 8.36219C4.01824 8.05539 4.21348 7.77648 4.33301 7.52547C4.45652 7.27445 4.51828 7.00551 4.51828 6.71863C4.51828 6.37199 4.42066 6.11301 4.22543 5.94168C4.03418 5.76637 3.77719 5.67871 3.45445 5.67871C3.11578 5.67871 2.78707 5.75641 2.46832 5.9118C2.14957 6.06719 1.81687 6.28832 1.47023 6.5752L0.466172 5.38586C0.717187 5.1707 0.982148 4.9675 1.26105 4.77625C1.54395 4.585 1.87066 4.4316 2.24121 4.31605C2.61574 4.19652 3.06398 4.13676 3.58594 4.13676C4.15969 4.13676 4.65176 4.24035 5.06215 4.44754C5.47652 4.65473 5.79527 4.93762 6.0184 5.29621C6.24152 5.65082 6.35309 6.05324 6.35309 6.50348C6.35309 6.98559 6.25746 7.42586 6.06621 7.8243C5.87496 8.22273 5.59605 8.61719 5.22949 9.00766C4.86691 9.39813 4.42863 9.83043 3.91465 10.3046L2.79105 11.3624V11.4461H6.59812V13Z"
        fill="currentColor"
      />
      <path
        d="M28.5 5.5H17.5C13.7867 5.5 11 8.18503 11 12"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.5 18.5H22.5C26.2133 18.5 29 15.815 29 12"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M26.5 8L28.4548 6.20711C28.8183 5.87377 29 5.70711 29 5.5C29 5.29289 28.8183 5.12623 28.4548 4.79289L26.5 3"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.5 16L11.5452 17.7929C11.1817 18.1262 11 18.2929 11 18.5C11 18.7071 11.1817 18.8738 11.5452 19.2071L13.5 21"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default GenerateIconWithNumber;
